<form [formGroup]="formGroup" id="step3Form">
  <div class="step3-form-container">
    <div class="row">
      @if (controls.meansOfSubsistence; as meansOfSubsistence) {
        <div class="standard-form-field radio-form-field meansOfSubsistenceField required-field">
          <label
            id="applicantMeansOfSubsistenceLabel"
            [class.invalid]="meansOfSubsistence.touched && meansOfSubsistence.invalid">
            {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantMeansOfSubsistenceInput"
            formControlName="meansOfSubsistence"
            (keydown)="firstInputKeydown($event)"
            [attr.aria-labelledby]="'applicantMeansOfSubsistenceLabel'"
            [attr.aria-invalid]="meansOfSubsistence.touched && meansOfSubsistence.invalid ? 'true' : null"
            [required]="true">
            @for (meanObj of selectsValues.MEANS_OF_SUBSISTENCE; track meanObj; let radioButtonIndex = $index) {
              <mat-radio-button id="meansOfSubsistence-{{ radioButtonIndex }}" [value]="meanObj.value">
                {{ meanObj.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.meansOfSubsistence.value === 'Oszczędności') {
      <div class="row">
        @if (controls.meansOfSubsistenceSavingsAmount; as meansOfSubsistenceSavingsAmount) {
          <div class="standard-form-field full-width-field meansOfSubsistenceSavingsAmount-field required-field">
            <label
              for="meansOfSubsistenceSavingsAmountInput"
              [class.invalid]="meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid">
              {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-AMOUNT.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <br />
              {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-AMOUNT.NEXT-LINE-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="meansOfSubsistenceSavingsAmountInput"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-AMOUNT.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="'false'"
                [attr.aria-describedby]="
                  meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid
                    ? 'meansOfSubsistenceSavingsAmountError'
                    : null
                "
                [attr.aria-invalid]="
                  meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid ? 'true' : null
                "
                [formControl]="meansOfSubsistenceSavingsAmount" />
              <!-- ERROR -->
              @if (meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid) {
                <mat-error id="meansOfSubsistenceSavingsAmountError">
                  {{ meansOfSubsistenceSavingsAmount.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if (controls.meansOfSubsistence.value === 'Inne') {
      <div class="row">
        @if (controls.meansOfSubsistenceOthers; as meansOfSubsistenceOthers) {
          <div class="standard-form-field full-width-field meansOfSubsistenceOthers-field required-field">
            <label
              for="meansOfSubsistenceOthersInput"
              [class.invalid]="meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid">
              {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-OTHERS.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              <br />
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="meansOfSubsistenceOthersInput"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-OTHERS.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="'true'"
                [attr.aria-describedby]="
                  meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid
                    ? 'meansOfSubsistenceOthersError'
                    : null
                "
                [attr.aria-invalid]="
                  meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid ? 'true' : null
                "
                [formControl]="meansOfSubsistenceOthers" />
              <!-- ERROR -->
              @if (meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid) {
                <mat-error id="meansOfSubsistenceOthersError">
                  {{ meansOfSubsistenceOthers.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    <div class="row">
      @if (controls.medicalInsurance; as medicalInsurance) {
        <div class="standard-form-field radio-form-field medicalInsurance-field required-field">
          <label
            id="applicantMedicalInsuranceLabel"
            [class.invalid]="medicalInsurance.touched && medicalInsurance.invalid">
            {{ 'PERSONAL_DATA_FORM.MEDICAL-INSURANCE.MAIN-LABEL' | translate }} <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantMedicalInsuranceInput"
            formControlName="medicalInsurance"
            [attr.aria-labelledby]="'applicantMedicalInsuranceLabel'"
            [attr.aria-invalid]="medicalInsurance.touched && medicalInsurance.invalid ? 'true' : null"
            [required]="true">
            @for (insuranceObj of selectsValues.MEDICAL_INSURANCE; track insuranceObj) {
              <mat-radio-button [value]="insuranceObj.value">
                {{ insuranceObj.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
    </div>
    <div class="row">
      @if (controls.familyMembersOutsidePoland; as familyMembersOutsidePoland) {
        <div class="standard-form-field radio-form-field familyMembersOutsidePoland-field required-field">
          <label
            id="applicantFamilyMembersOutsidePolandLabel"
            [class.invalid]="familyMembersOutsidePoland.touched && familyMembersOutsidePoland.invalid">
            {{ 'PERSONAL_DATA_FORM.FAMILY-MEMBERS-OUTSIDE-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantFamilyMembersOutsidePolandInput"
            formControlName="familyMembersOutsidePoland"
            [attr.aria-labelledby]="'applicantFamilyMembersOutsidePolandLabel'"
            [attr.aria-invalid]="
              familyMembersOutsidePoland.touched && familyMembersOutsidePoland.invalid ? 'true' : null
            "
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
    <div class="row">
      @if (controls.applyingForExperience; as applyingForExperience) {
        <div class="standard-form-field full-width-field applyingForExperience-field required-field">
          <label
            for="applicantApplyingForExperienceInput"
            [class.invalid]="applyingForExperience.touched && applyingForExperience.invalid">
            {{ 'PERSONAL_DATA_FORM.APPLYING-FOR-EXPERIENCE.UPPER-LABEL' | translate }}
            <br />
            {{ 'PERSONAL_DATA_FORM.APPLYING-FOR-EXPERIENCE.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <textarea
              matInput
              id="applicantApplyingForExperienceInput"
              formControlName="applyingForExperience"
              aria-describedby="applyingForExperienceTooltip"
              cdkTextareaAutosize
              cdkAutosizeMinRows="8"
              cdkAutosizeMaxRows="8"></textarea>
            <!-- CUSTOM TOOLTIP -->
            <button
              mat-icon-button
              type="button"
              matSuffix
              [attr.aria-label]="'COMMON.HELP' | translate"
              customTooltip
              [contentTemplate]="applyingForExperienceTooltipTemplate">
              <mat-icon>help_outline</mat-icon>
            </button>
            <!-- ERROR -->
            @if (applyingForExperience.touched && applyingForExperience.invalid) {
              <mat-error id="applicantApplyingForExperienceError">
                {{ applyingForExperience.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div class="row" [class.mark-red-border]="controls.currentlyDetained.value === true && mode === 'employee'">
      @if (controls.currentlyDetained; as currentlyDetained) {
        <div class="standard-form-field radio-form-field currentlyDetained-field required-field">
          <label
            id="applicantCurrentlyDetainedLabel"
            [class.invalid]="currentlyDetained.touched && currentlyDetained.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-DETAINED.MAIN-LABEL' | translate }} <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantCurrentlyDetainedInput"
            formControlName="currentlyDetained"
            [attr.aria-labelledby]="'applicantCurrentlyDetainedLabel'"
            [attr.aria-invalid]="currentlyDetained.touched && currentlyDetained.invalid ? 'true' : null"
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.currentlyDetained.value === true) {
      <!-- ====================================================================== 1 ============================= -->
      <div
        class="row"
        [class.mark-red-border]="controls.inGuardedCentre.value === true && mode === 'employee'"
        aria-live="polite">
        @if (controls.inGuardedCentre; as inGuardedCentre) {
          <div class="standard-form-field radio-form-field inGuardedCentre-field required-field">
            <label
              id="applicantInGuardedCentreLabel"
              [class.invalid]="inGuardedCentre.touched && inGuardedCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.DETAINED_IN_GUARDED_CENTRE' | translate }} <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantInGuardedCentreInput"
              formControlName="inGuardedCentre"
              [attr.aria-labelledby]="'applicantInGuardedCentreLabel'"
              [attr.aria-invalid]="inGuardedCentre.touched && inGuardedCentre.invalid ? 'true' : null"
              [required]="true">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inGuardedCentre.value === true) {
          @if (controls.inGuardedCentreComment; as inGuardedCentreComment) {
            <div class="standard-form-field full-width-field inGuardedCentreComment-field" aria-live="polite">
              <label
                for="applicantInGuardedCommentInput"
                [class.invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="applicantInGuardedCommentInput"
                  formControlName="inGuardedCentreComment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"></textarea>
                <!-- ERROR -->
                @if (inGuardedCentreComment.touched && inGuardedCentreComment.invalid) {
                  <mat-error id="applicantInGuardedCommentError">
                    {{ inGuardedCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 2 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inDetentionCentre.value === true && mode === 'employee'">
        @if (controls.inDetentionCentre; as inDetentionCentre) {
          <div class="standard-form-field radio-form-field inDetentionCentre-field required-field">
            <label
              id="applicantInDetentionCentreLabel"
              [class.invalid]="inDetentionCentre.touched && inDetentionCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.IN_DETENTION_CENTRE' | translate }} <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantInDetentionCentreInput"
              formControlName="inDetentionCentre"
              [attr.aria-labelledby]="'applicantInDetentionCentreLabel'"
              [attr.aria-invalid]="inDetentionCentre.touched && inDetentionCentre.invalid ? 'true' : null"
              [required]="true">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inDetentionCentre.value === true) {
          @if (controls.inDetentionCentreComment; as inDetentionCentreComment) {
            <div class="standard-form-field full-width-field inDetentionCentreComment-field" aria-live="polite">
              <label
                for="applicantInDetentionCentreCommentInput"
                [class.invalid]="inDetentionCentreComment.touched && inDetentionCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="applicantInDetentionCentreCommentInput"
                  formControlName="inDetentionCentreComment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"></textarea>
                <!-- ERROR -->
                @if (inDetentionCentreComment.touched && inDetentionCentreComment.invalid) {
                  <mat-error id="applicantInDetentionCentreCommentError">
                    {{ inDetentionCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 3 ============================= -->
      <div class="row" [class.mark-red-border]="controls.hasBanOnLeavingCountry.value === true && mode === 'employee'">
        @if (controls.hasBanOnLeavingCountry; as hasBanOnLeavingCountry) {
          <div class="standard-form-field radio-form-field hasBanOnLeavingCountry-field required-field">
            <label
              id="applicantHasBanOnLeavingCountryLabel"
              [class.invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid">
              {{ 'PERSONAL_DATA_FORM.HAS_BAN_ON_LEAVING_THE_COUNTRY' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantHasBanOnLeavingCountryInput"
              formControlName="hasBanOnLeavingCountry"
              [attr.aria-labelledby]="'applicantHasBanOnLeavingCountryLabel'"
              [attr.aria-invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid ? 'true' : null"
              [required]="true">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasBanOnLeavingCountry.value === true) {
          @if (controls.hasBanOnLeavingCountryComment; as hasBanOnLeavingCountryComment) {
            <div class="standard-form-field full-width-field hasBanOnLeavingCountryComment-field" aria-live="polite">
              <label
                for="applicantHasBanOnLeavingCountryCommentInput"
                [class.invalid]="hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="applicantHasBanOnLeavingCountryCommentInput"
                  formControlName="hasBanOnLeavingCountryComment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"></textarea>
                <!-- ERROR -->
                @if (hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid) {
                  <mat-error id="applicantHasBanOnLeavingCountryCommentError">
                    {{ hasBanOnLeavingCountryComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 4 ============================= -->
      <div
        class="row"
        [class.mark-red-border]="controls.hasSentenceOfImprisonment.value === true && mode === 'employee'">
        @if (controls.hasSentenceOfImprisonment; as hasSentenceOfImprisonment) {
          <div class="standard-form-field radio-form-field hasSentenceOfImprisonment-field required-field">
            <label
              id="applicantHasSentenceOfImprisonmentLabel"
              [class.invalid]="hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCED_IMPRISONMENT' | translate }} <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantHasSentenceOfImprisonmentInput"
              formControlName="hasSentenceOfImprisonment"
              [attr.aria-labelledby]="'applicantHasSentenceOfImprisonmentLabel'"
              [attr.aria-invalid]="
                hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid ? 'true' : null
              "
              [required]="true">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasSentenceOfImprisonment.value === true) {
          @if (controls.hasSentenceOfImprisonmentComment; as hasSentenceOfImprisonmentComment) {
            <div class="standard-form-field full-width-field hasSentenceOfImprisonmentComment-field" aria-live="polite">
              <label
                for="applicantHasSentenceOfImprisonmentCommentInput"
                [class.invalid]="hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="applicantHasSentenceOfImprisonmentCommentInput"
                  formControlName="hasSentenceOfImprisonmentComment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"></textarea>
                <!-- ERROR -->
                @if (hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid) {
                  <mat-error id="applicantHasSentenceOfImprisonmentCommentError">
                    {{ hasSentenceOfImprisonmentComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 5 ============================= -->
      <div class="row" [class.mark-red-border]="controls.temporarilyArrested.value === true && mode === 'employee'">
        @if (controls.temporarilyArrested; as temporarilyArrested) {
          <div class="standard-form-field radio-form-field temporarilyArrested-field required-field">
            <label
              id="applicantTemporarilyArrestedLabel"
              [class.invalid]="temporarilyArrested.touched && temporarilyArrested.invalid">
              {{ 'PERSONAL_DATA_FORM.TEMPORARILY_ARRESTED' | translate }} <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantTemporarilyArrestedInput"
              formControlName="temporarilyArrested"
              [attr.aria-labelledby]="'applicantTemporarilyArrestedLabel'"
              [attr.aria-invalid]="temporarilyArrested.touched && temporarilyArrested.invalid ? 'true' : null"
              [required]="true">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.temporarilyArrested.value === true) {
          @if (controls.temporarilyArrestedComment; as temporarilyArrestedComment) {
            <div class="standard-form-field full-width-field temporarilyArrestedComment-field" aria-live="polite">
              <label
                for="applicantTemporarilyArrestedCommentInput"
                [class.invalid]="temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="applicantTemporarilyArrestedCommentInput"
                  formControlName="temporarilyArrestedComment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"></textarea>
                <!-- ERROR -->
                @if (temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid) {
                  <mat-error id="applicantTemporarilyArrestedCommentError">
                    {{ temporarilyArrestedComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
    }
    <div class="row">
      @if (controls.wasSentencedInPoland; as wasSentencedInPoland) {
        <div class="standard-form-field radio-form-field wasSentencedInPoland-field required-field">
          <label
            id="applicantWasSentencedInPolandLabel"
            [class.invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid">
            {{ 'PERSONAL_DATA_FORM.WAS-SENTENCED-IN-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantWasSentencedInPolandInput"
            formControlName="wasSentencedInPoland"
            [attr.aria-labelledby]="'applicantWasSentencedInPolandLabel'"
            [attr.aria-invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid ? 'true' : null"
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.wasSentencedInPoland.value === true) {
        @if (controls.sentenceReason; as sentenceReason) {
          <div class="standard-form-field full-width-field sentenceReason-field" aria-live="polite">
            <label
              for="applicantSentenceReasonInput"
              [class.invalid]="sentenceReason.touched && sentenceReason.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCE-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantSentenceReasonInput"
                formControlName="sentenceReason"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (sentenceReason.touched && sentenceReason.invalid) {
                <mat-error id="applicantSentenceReasonError">
                  {{ sentenceReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.currentlySubjectOfProceedings; as currentlySubjectOfProceedings) {
        <div class="standard-form-field radio-form-field currentlySubjectOfProceedings-field required-field">
          <label
            id="applicantCurrentlySubjectOfProceedingsLabel"
            [class.invalid]="currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-SUBJECT-OF-PROCEEDINGS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantCurrentlySubjectOfProceedingsInput"
            formControlName="currentlySubjectOfProceedings"
            [attr.aria-labelledby]="'applicantCurrentlySubjectOfProceedingsLabel'"
            [attr.aria-invalid]="
              currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid ? 'true' : null
            "
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.currentlySubjectOfProceedings.value === true) {
        @if (controls.proceedingsReason; as proceedingsReason) {
          <div class="standard-form-field full-width-field proceedingsReason-field" aria-live="polite">
            <label
              for="applicantProceedingsReasonInput"
              [class.invalid]="proceedingsReason.touched && proceedingsReason.invalid">
              {{ 'PERSONAL_DATA_FORM.PROCEEDINGS-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantProceedingsReasonInput"
                formControlName="proceedingsReason"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (proceedingsReason.touched && proceedingsReason.invalid) {
                <mat-error id="applicantProceedingsReasonError">
                  {{ proceedingsReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.liabilitiesFromVerdicts; as liabilitiesFromVerdicts) {
        <div class="standard-form-field radio-form-field liabilitiesFromVerdicts-field required-field">
          <label
            id="applicantLiabilitiesFromVerdictsLabel"
            [class.invalid]="liabilitiesFromVerdicts.touched && liabilitiesFromVerdicts.invalid">
            {{ 'PERSONAL_DATA_FORM.LIABILITIES-FROM-VERDICTS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="applicantLiabilitiesFromVerdictsInput"
            formControlName="liabilitiesFromVerdicts"
            (keydown.Tab)="liabilitiesFromVerdicts.value !== true ? emitLastFieldTabPressed($event) : undefined"
            [attr.aria-labelledby]="'applicantLiabilitiesFromVerdictsLabel'"
            [attr.aria-invalid]="liabilitiesFromVerdicts.touched && liabilitiesFromVerdicts.invalid ? 'true' : null"
            [required]="true">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.liabilitiesFromVerdicts.value === true) {
        @if (controls.liabilitiesDescription; as liabilitiesDescription) {
          <div class="standard-form-field full-width-field liabilitiesDescription-field" aria-live="polite">
            <label
              for="applicantLiabilitiesDescriptionInput"
              [class.invalid]="liabilitiesDescription.touched && liabilitiesDescription.invalid">
              {{ 'PERSONAL_DATA_FORM.LIABILITIES-DESCRIPTION.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                (keydown.Tab)="emitLastFieldTabPressed($event)"
                id="applicantLiabilitiesDescriptionInput"
                formControlName="liabilitiesDescription"
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"></textarea>
              <!-- ERROR -->
              @if (liabilitiesDescription.touched && liabilitiesDescription.invalid) {
                <mat-error id="applicantLiabilitiesDescriptionError">
                  {{ liabilitiesDescription.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
  </div>
</form>

<ng-template #applyingForExperienceTooltipTemplate>
  <div id="applyingForExperienceTooltip" class="customTooltip" role="note">
    <h3>{{ 'PERSONAL_DATA_FORM.EXAMPLE' | translate }}</h3>
    <span translate="EXPERIENCE_TOOLTIP.ROW_1"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_2"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_3"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_4"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_5"></span>
  </div>
</ng-template>
